@import "../../../../../../styles/variables.scss";

.conversational-search-banner-dynamic-feedback {
  display: flex;
  justify-content: flex-end;
  font-size: 14px;
  line-height: 20px;
  min-height: 32px;

  // QDS buttons sizing change breakpoint
  @media (max-width: 980px) {
    min-height: 44px;
  }

  &-initial {
    align-items: center;
    display: flex;

    &__text {
      margin-right: 8px;
    }
  }

  .conversational-search-actions {
    &:first-of-type {
      margin-right: 8px;
    }
  }

  &-interacted {
    align-items: center;
    animation: fadeIn 1s ease-in;
    display: flex;

    se-icon {
      margin-right: 4px;
    }

    qds-button {
      margin-left: 8px;
    }
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
